<template>
  <button class="consent-settings" @click="openModal" aria-label="Consent settings">
    <b-icon icon="gear" aria-hidden="true" role="presentation"></b-icon>
  </button>
</template>

<script>
  export default {
    name: "ConsentButton",

    methods: {
      openModal() {
        this.$root.$emit('bv::show::modal', 'modal-consent');
      }
    }
  }
</script>

<style scoped lang="scss">
  .consent-settings {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 60px;
    height: 60px;
    padding: 10px;
    margin: 0 .2em 0 0;
    background: white;
    color: #192e5b;

    border-top-right-radius: 50%;
    border: 2px solid #192e5b;

    z-index: 0;
    cursor: pointer;

    transform: scale(.7);
    transform-origin: bottom left;
    transition: all .3s ease;

    svg {
      font-size: 35px;
      margin-top: 2px;
      margin-left: -2px
    }

    &:hover {
      transform: scale(1);

      svg {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        transition-duration: 0.8s;
        transition-property: transform;
      }
    }
  }
</style>
